module.exports = __webpack_public_path__ + "img/australia-external-causes-female.a125e0cd.png";